import React from 'react'
import classes from "./styles.module.scss";

export interface PulseIndicatorProps extends React.InputHTMLAttributes<HTMLInputElement> {
    size?: number; // diameter in px
    color?: string; // pulse color
}

const PulseIndicator: React.FC<PulseIndicatorProps> = ({ size = 20, color = "#008FFF" }) => {
    return (
        <div
            className={classes.PulseIndicator}
            style={{ width: size, height: size }}
        >
            <span
                className={classes.pulseRing}
                style={{ backgroundColor: color }}
            />
            <span
                className={classes.pulseCore}
                style={{ backgroundColor: color, boxShadow: `0 0 4px ${color}80` }}
            />
        </div>
    );
}

export default PulseIndicator